<template>
  <!-- 头部 -->
  <div class="header-div">
  <!-- :disabled="true" 禁用导致部分浏览器点不了 -->
    <van-search v-model="keyValue" show-action :placeholder="placeholderTip">  
      <template #left>
        <div @click.stop="backFn" class="back-icon-div">
          <van-icon size="22" name="arrow-left"  color="#333333" />
        </div>
      </template>
      <template #action>
        <div @click.stop="actvCartFn" class="search-item-right">
          <van-icon color="#333333" v-if="props.isShowCart" size="22" name="cart-o" />
          <KSShareStoreShareButton
            v-if="shareBtnShow"
            :shareImageUrl="storeInfo ? storeInfo.storeIcon : ''"
            :shareTitle="storeInfo ? storeInfo.name : ''"
            sourceType="Store"
            :sourceId="storeInfo ? storeInfo.id : ''"
          />
        </div>
      </template>
    </van-search>
  </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    isShowCart?: boolean,
    placeholderTip?: string,
    shareBtnShow?: boolean,
    storeInfo?: any
  }>(),
  {
    isShowCart: false,
    placeholderTip: 'Search in store'
  }
)
const routeQuery: any = useRoute().query
const keyValue = ref<string>(routeQuery.keyword || '')
const router = useRouter()
const actvCartFn = () => {
  if(props.isShowCart) router.push('shopping-cart')
}
const backFn = () => {
  window.history.back()
}
</script>
<style lang='scss' scoped>
.header-div {
  width: 100%;
  position: fixed;
  top: 0px; 
  padding: 0px;
  background-color: white;
  z-index: 99;
  padding-bottom: 18px;
  .van-search {
    padding-bottom: 0;
  }
  .back-icon-div {
    width: 70px;
  }
  .search-item-right {
    width: 50px;
    @include center();
  }
  .van-search {
    padding-left: 10px;
  }
  :deep() .share-button-div i {
    color: #333333;
  }
}
</style>